import { mediaQueries, spacingBottom, spacingTop } from '@digando/react-component-library';
import styled from '@emotion/styled';
import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { ProductType } from '../../@types/codegen/graphql';
import { DigandoBreadcrumb } from '../breadcrumb/digando-breadcrumb';

interface IProductBreadcrumbProps {
  category: ProductType['mainCategory'];
  productTitle: string;
}

export const ProductBreadcrumb: FC<IProductBreadcrumbProps> = ({ category, productTitle }) => {
  const [t] = useTranslation('common');

  const links = [
    { href: '/', name: t('common:navigation.breadcrumb.homepage') },
  ];

  links.push({ href: '/baumaschinen-mieten', name: t('common:navigation.breadcrumb.categories') });

  if (category?.parent) {
    links.push({ href: category?.parent?.relativeUrl ?? '', name: category?.parent?.title ?? '' })
  }

  links.push({ href: category?.relativeUrl ?? '', name: category?.title ?? '' });

  return (
    <BreadcrumbWrapper>
      <DigandoBreadcrumb items={links} actualPage={productTitle} />
    </BreadcrumbWrapper>
  );
};

const BreadcrumbWrapper = styled.div`
  display: none;

  @media ${mediaQueries.tablet} {
    display: block;
    ${spacingBottom(2)};
    ${spacingTop(0.5)};
  }

  @media print {
    display: none;
  }
`;
